import { createSelector } from '@reduxjs/toolkit';
import { computersOnNhn } from './computers-on-nhn';
import { externalConnectionsOnNhn } from './external-connections-on-nhn';

export const externalItemsOnNhn = createSelector(
  computersOnNhn,
  externalConnectionsOnNhn,
  (computers, externalConnections) => computers.length > 0 || externalConnections.length > 0,
);
